import { Component } from '@angular/core';

@Component({
  selector: 'app-footer',
  template: require('./footer.component.html'),
  styles: [require('./footer.component.scss')]
})
export class FooterComponent {
  public today: number = Date.now();
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/components/footer/footer.component.ts